module.exports = "\n<router-outlet>\n</router-outlet>\n"